import { useBreakpointValue } from 'native-base'

const useCommonResponsiveValues = () => {
	const containerWidth = useBreakpointValue({
		base: '100%',
		lg: '992px',
		xl: '1280px',
	})

	return {
		containerWidth,
	}
}

export default useCommonResponsiveValues
